import React from "react";
import { Linkedin, Github, Instagram } from "lucide-react";
import { useLang } from "../../context/LanguageContext";
import { t } from "../../translations";

export default function Footer() {
    const { lang } = useLang();
    const tr = t[lang].footer;
    return (
        <footer className="py-16 bg-surface border-t border-separator transition-colors duration-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col sm:flex-row items-center justify-between space-y-6 sm:space-y-0">
                    {/* Logo and Name */}
                    <div className="flex flex-col items-center sm:items-start">
                        <a
                            href="#hero"
                            className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600 dark:from-blue-400 dark:to-purple-400 hover:from-blue-700 hover:to-purple-700 dark:hover:from-blue-500 dark:hover:to-purple-500 transition-colors duration-300"
                        >
                            Hedi Bou Maiza
                        </a>
                        <p className="mt-2 text-label-secondary text-[15px] font-medium">
                            {tr.role}
                        </p>
                    </div>

                    {/* Social Links with Labels */}
                    <div className="flex flex-col items-center sm:items-end space-y-4">
                        <div className="flex gap-6">
                            <a
                                href="https://github.com/hediipor"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-2 min-h-[44px] text-label-secondary hover:text-accent-text transition-colors"
                            >
                                <Github className="w-5 h-5" />
                                <span className="text-sm font-medium">GitHub</span>
                            </a>
                            <a
                                href="https://www.linkedin.com/in/hedi-bou-maiza/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-2 min-h-[44px] text-label-secondary hover:text-accent-text transition-colors"
                            >
                                <Linkedin className="w-5 h-5" />
                                <span className="text-sm font-medium">LinkedIn</span>
                            </a>
                            <a
                                href="https://www.instagram.com/hedi_bou_maiza/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-2 min-h-[44px] text-label-secondary hover:text-accent-text transition-colors"
                            >
                                <Instagram className="w-5 h-5" />
                                <span className="text-sm font-medium">Instagram</span>
                            </a>
                        </div>
                        <p className="text-label-tertiary text-[13px]">
                            &copy; {new Date().getFullYear()} Hedi Bou Maiza. {tr.rights}
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
